import React from 'react';
import PropTypes from 'prop-types';

import { useCombobox } from './ComboboxContext';
import ComboboxFooter from './ComboboxFooter';

const ComboboxList = ({ children }) => {
  const { isOpen, filteredChildren, menuMaxHeight } = useCombobox();

  if (!isOpen) return null;

  const filtered = filteredChildren(children);

  const footer = filtered.find(child => child?.type === ComboboxFooter);
  const items = filtered.filter(child => child?.type !== ComboboxFooter);

  if (items.length === 0 && !footer) return null;

  return (
    <div className="combobox__menu" style={menuMaxHeight ? { maxHeight: menuMaxHeight } : undefined}>
      {items.length > 0 && (
        <ul className="combobox__list" role="listbox">
          {items}
        </ul>
      )}
      {footer}
    </div>
  );
};

ComboboxList.propTypes = {
  children: PropTypes.node,
};

export default ComboboxList;
